import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import * as moment from 'moment';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatError } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';

const SUPPORTED_PICKER_TYPES = ['past-only', 'future-only', 'last-month-only'];

@Component({
  selector: 'app-form-date-range',
  templateUrl: './form-date-range.component.html',
  styleUrls: ['./form-date-range.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgClass, ReactiveFormsModule,
    MatFormField, MatLabel, MatInput, MatSuffix, MatError,
    MatDatepickerInput, MatDatepickerToggle, MatDatepicker,
    TranslateModule
  ]
})
export class FormDateRangeComponent implements Field, OnInit {
  config: FieldConfig;
  group: FormGroup;

  fromPlaceholder = 'Start Date';
  toPlaceholder = 'End Date';
  minDate: Date | null = null;
  maxDate: Date | null = null;

  get isVisible(): boolean {
    if (this.config.hide) { return false; }
    if (this.config.allowedPickerDate && !SUPPORTED_PICKER_TYPES.includes(this.config.allowedPickerDate)) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    const fmt = sessionStorage.getItem('IniDateFieldFormat');
    if (fmt) {
      this.fromPlaceholder = fmt;
      this.toPlaceholder = fmt;
    }
    this.computeDateConstraints();
    if (this.config.disbaledProperty) {
      if (this.group.controls[this.config.name]) {
        this.group.controls[this.config.name].disable();
      }
      if (this.config.toName && this.group.controls[this.config.toName]) {
        this.group.controls[this.config.toName].disable();
      }
    }
  }

  private computeDateConstraints(): void {
    const type = this.config.allowedPickerDate;
    const today = new Date();
    if (type === 'past-only') {
      this.maxDate = today;
    } else if (type === 'future-only') {
      this.minDate = today;
    } else if (type === 'last-month-only') {
      this.minDate = moment().subtract(1, 'month').startOf('month').toDate();
      this.maxDate = today;
    }
  }
}
